export default __webpack_public_path__ + "79b3ed843b7acde4fc3892963a26c5dd.svg";